import type { MoneyCents } from './types';

export function assertMoneyCents(value: number, label = 'Geldbetrag'): MoneyCents {
  if (!Number.isSafeInteger(value)) {
    throw new RangeError(`${label} muss eine sichere Ganzzahl in Cent sein.`);
  }
  if (value < 0) {
    throw new RangeError(`${label} darf nicht negativ sein.`);
  }
  return value;
}

export function assertBetCents(value: number): MoneyCents {
  const bet = assertMoneyCents(value, 'Einsatz');
  if (bet <= 0 || bet % 10 !== 0) {
    throw new RangeError('Der Einsatz muss positiv und durch zehn Gewinnlinien teilbar sein.');
  }
  return bet;
}

export function addMoneyCents(left: MoneyCents, right: MoneyCents): MoneyCents {
  return assertMoneyCents(
    assertMoneyCents(left, 'Linker Geldbetrag') + assertMoneyCents(right, 'Rechter Geldbetrag'),
  );
}

export function debitMoneyCents(balance: MoneyCents, amount: MoneyCents): MoneyCents {
  const safeBalance = assertMoneyCents(balance, 'Guthaben');
  const safeAmount = assertMoneyCents(amount, 'Abbuchung');
  if (safeAmount > safeBalance) {
    throw new RangeError('Nicht genügend Guthaben.');
  }
  return safeBalance - safeAmount;
}

export function multiplyMoneyCents(amount: MoneyCents, factor: number): MoneyCents {
  const safeAmount = assertMoneyCents(amount);
  if (!Number.isSafeInteger(factor) || factor < 0) {
    throw new RangeError('Der Multiplikator muss eine nichtnegative sichere Ganzzahl sein.');
  }
  return assertMoneyCents(safeAmount * factor);
}

export function linePayoutCents(payoutCredits: number, betCents: MoneyCents): MoneyCents {
  if (!Number.isSafeInteger(payoutCredits) || payoutCredits < 0) {
    throw new RangeError('Linien-Credits müssen eine nichtnegative sichere Ganzzahl sein.');
  }
  const lineBet = assertBetCents(betCents) / 10;
  return multiplyMoneyCents(lineBet, payoutCredits);
}

